var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "gridChatWindow", staticClass: "grid-chat-window" },
    [
      _c("GridContactList", {
        attrs: {
          contact: _vm.contact,
          contacts: _vm.contacts,
          loading: _vm.loading,
          maxGridConversationsWidth: _vm.maxGridConversationsWidth,
          minGridConversationsWidth: _vm.minGridConversationsWidth,
        },
        on: {
          width: _vm.resizingGridConversation,
          loadMoreContacts: function ($event) {
            return _vm.$emit("loadMoreContacts")
          },
        },
      }),
      _vm._v(" "),
      _vm.contact
        ? _c("GridChatWindowContact", {
            style: { width: _vm.chatWindowWidth },
            attrs: {
              contact: _vm.contact,
              maxUserInfoWidgetWidth: _vm.maxUserInfoWidgetWidth,
              minUserInfoWidgetWidth: _vm.minUserInfoWidgetWidth,
            },
            on: { width: _vm.resizingUserInfoWidget },
          })
        : [
            _c(
              "div",
              {
                staticClass: "no-active-conversation",
                style: {
                  width: "calc(100% - " + this.gridConversationWidth + "px)",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "no-active-conversation-content" },
                  [
                    _c("NoActiveConversation"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "no-active-conversation-content-title" },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("chatWindow.thereIsNoChatContent"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "no-active-conversation-content-description",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t("chatWindow.thereIsNoChatContentDsc")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }